<template>
  <slider-rules />

  <the-nav />

  <div class="main-wrap">
    <div id="rules">
      <div class="faq-fl">
        <p>
          Регистрация и совершение ставок в игровом клубе подразумевает согласие игрока с данными правилами, а также
          правилами игр и прочими положениями, а также дает согласие на получение рассылки на свой электронный ящик или
          мобильный телефон. Для регистрации в игровом клубе игроку должно быть полных 18 лет. Лица, не достигшие
          восемнадцатилетнего возраста, к игре в игровом клубе Миллион не допускаются.
        </p>

        <p>Администрация Клуба гарантирует полное обеспечение конфиденциальности данных Клиента.</p>
        <h2><span>1.</span>Обязанности Клиента:</h2>

        <p class="block">
          <span>1.1</span> Клиент полностью понимает содержащиеся здесь правила, положения, требования и условия,
          соглашается с ними, следует им, а также соглашается с тем, что Администрация Клуба оставляет за собой право в
          любое время и без предварительного уведомления вносить любые изменения в порядок работы Клуба, в т.ч. в
          программное обеспечение и в порядок предоставления услуг, а также в соответствии с текущим законодательством
          изменять требования, исполнение которых необходимо для доступа и использования услуг.
        </p>

        <p class="block">
          <span>1.2</span> Клиент соглашается с тем, что содержание веб-сайта и программного обеспечения Клуба
          предназначено исключительно для его личного некоммерческого интереса. Клиент обязуется не копировать, не
          воспроизводить и не публиковать какие-либо элементы и содержание сайта Клуба или программного обеспечения
          Клуба.
        </p>

        <p class="block">
          <span>1.3</span> При регистрации в Клубе Клиент принимает все условия пополнения игрового счета с помощью
          платежных систем, представленных Клубом, и обязуется четко следовать их инструкциям. При пополнении игрового
          счета Клуб не взимает комиссию с платежей. Комиссия взимается платежной системой.
        </p>

        <p class="block">
          <span>1.4</span> Данные, представляемые Клиентом во время регистрации, должны быть достоверными. При
          необходимости, администрация может запросить документальное подтверждение личности Клиента.
        </p>

        <p class="block">
          <span>1.5</span> Вы в полной мере осознаете, что существует риск потери денежных средств в процессе
          использования услуг в Клубе и Вы несете полную ответственность за любые потери связанные с использованием
          услуг Клуба. Вы согласны с тем, что пользуетесь услугами исключительно по собственному выбору, решению и на
          свой собственный риск. Вы не имеете права предъявлять какие-либо претензии к Компании в связи с Вашими
          убытками, потерями и/или проигрышами.
        </p>

        <h2><span>2.</span>Аккаунт клиента может быть заблокирован в следующих случаях:</h2>

        <p class="block">
          <span>2.1</span> Если с аккаунта Клиента производились подозрительные действия, схожие с мошенническими.
        </p>

        <p class="block">
          <span>2.2</span> Если Клиент использует программное обеспечение, способное повлиять на исход результатов игры
          или работу Клуба.
        </p>

        <p class="block"><span>2.3</span> Если Клиент использует свой аккаунт для отмывания денежных средств.</p>

        <p class="block"><span>2.4</span> Если клиент использует ресурсы Клуба для осуществления обменных операций.</p>

        <p class="block">
          <span>2.5</span> Если администрацией принято решение о блокировке аккаунта Клиента, все его данные удаляются
          из базы Клуба. Возврат Клиенту средств, находящихся в момент блокировки на счете, рассматривается в
          индивидуальном порядке.
        </p>

        <p class="block">
          <span>2.6</span> В случае умышленного нарушения правил Клиентом Клуб оставляют за собой право заморозить счет
          для выяснения личности и целей Клиента.
        </p>

        <p class="block">
          <span>2.7</span> Спорные ситуации рассматриваются администрацией клуба в индивидуальном порядке после
          обращения Клиента на электронный адрес службы поддержки с указанием контактного телефона, логина и описания
          ситуации.
        </p>

        <p class="block">
          <span>2.8</span> Клуб оставляет за собой право не объяснять пользователю причины блокировки аккаунта.
        </p>

        <p class="block"><span>2.9</span> Использование Клиентом нескольких аккаунтов (мультиаккаунтинг).</p>

        <h2><span>3.</span>Услуги Клуба:</h2>

        <p class="block">
          <span>3.1</span> Каждый Клиент Клуба может пользоваться полным комплектом услуг, предлагаемых на сайте.
        </p>

        <p class="block">
          <span>3.2</span> В случае обрыва связи не по вине Клуба администрация не несет ответственности за материальные
          потери Клиента.
        </p>

        <p class="block">
          <span>3.3</span> Технические неполадки, возникшие на оборудовании Клуба, руководство заведения гарантирует
          исправить в кратчайший срок.
        </p>

        <p class="block">
          <span>3.4</span> В случае форс-мажорных обстоятельств, приведших к сбою системы, возможно аннулирование всех
          ставок и их результатов. Спорные ситуации решаются по усмотрению Администрации Клуба.
        </p>

        <h2><span>4.</span>Пополнение и выплата Клуба:</h2>

        <p class="block">
          <span>4.1</span> Если Вы хотите принять участие в азартных играх в Клубе, Вы должны разместить на Вашем
          аккаунте денежные средства.
        </p>

        <p class="block">
          <span>4.2</span> Вы подтверждаете и обязуетесь, что происхождение денежных средств, которые Вы вносите на Ваш
          аккаунт, не имеют уголовное и/или незаконное и/или неразрешенное происхождение
        </p>

        <p class="block">
          <span>4.3</span> Вы обязуетесь не отказываться от ранее проведенных транзакций /или отрицать либо отменять
          какие-либо платежи, сделанные Вами, которые могут стать причиной возврата платежа третьей стороной во
          избежание любой законной ответственности.
        </p>

        <p class="block">
          <span>4.4</span> Компания не принимаем денежные средства от третьих лиц, то есть друзей, родственников,
          партнеров и/или супругов. Вам необходимо вносить денежные средства на Ваш аккаунт только со счета /системы
          и/или расчетных карт, которые зарегистрированы на Ваше имя. Если же во время проверки безопасности, мы
          констатировали нарушение данного условия, то все выигрыши будут конфискованы и возвращены .
        </p>

        <p class="block">
          <span>4.5</span> Если запрошен банковский перевод на возврат денежных средств законному владельцу, то все
          банковские расходы /комиссии будут покрываться получателем.
        </p>

        <p class="block">
          <span>4.6</span> При оформлении заявки на выплату средств, необходимо учитывать следующие моменты:
        </p>

        <p class="block"><span>4.6.1</span> Информация в Вашем профиле должна быть заполнена;</p>

        <p class="block">
          <span>4.6.2</span> Средства должны быть выведены тем же методом, который ранее использовался для пополнения
          счета;
        </p>

        <p class="block">
          <span>4.6.3</span> Мы имеем право удержать комиссию, в размере наших затрат, на вывод денежных средств,
          которые не были задействованы в игре;
        </p>

        <p class="block">
          <span>4.7</span> Пополнение игрового счета на сайте возможно с практически всеми видами пополнения, такие как:
          СБП, ЮMoney , QIWI, МИР, Visa, MasterCard и криптовалюта.
        </p>

        <p class="block">
          <span>4.8</span> Ограничение на пополнение счета отсутствуют. Минимальная сумма для снятия со счета 300
          рублей.
        </p>

        <p class="block">
          <span>4.9</span> Запросы на выплату обрабатываются моментально, с нашей стороны, после проверки службой
          безопасности, которая составляет от 20 минут до 3 часов, но возможны заддержки со стороны принимающей
          платежной системы, не зависящие от нас. Максимально допустимое время на выплату 24 часа. При выплате выигрыша
          может взыматься комиссия.
        </p>

        <p class="block">
          <span>4.10</span> Игрок имеет право потребовать возврат всей суммы депозита (за вычетом комиссии платежной
          системы) в случае, если он не сделал ни одной ставки после этого депозита. В том случае, если ставки были
          сделаны игроком, но объем сделанных ставок оказывается меньше двойного размера платежа, администрация имеет
          право удержать в свою пользу 20% от запрошенной на вывод суммы. Сумма депозита при возможности возвращается на
          ту же платежную систему, с которой был совершен депозит, за вычетом комиссии платежной системы, размер которой
          определяется администрацией проекта.
        </p>

        <p class="block">
          <span>4.11</span> В календарные сутки Клиент может совершить не более 5 снятий со счета. Если будет совершенно
          более 5 снятий все последующие снятия могут быть возращены оператором обратно на счет.
        </p>

        <p class="block">
          <span>4.12</span> В календарные сутки Клиент может совершить снятие со счета от 10 000 до 500 000 рублей в
          зависимости от уровня игрока, обработка большей суммы совершается по запросу в службу поддержки и на
          усмотрение администратора, а также в зависимости от уровня игрока.
        </p>

        <p class="block">
          <span>4.13</span> Любой депозит, требует выполнения условия оборота ставок. Вывод средств возможен только при
          условии выполнения оборота по ставкам не менее чем x2 от суммы вашего депозита. Ставку на рулетке и блекджек
          считает 20% от суммы ставки.
        </p>

        <h2><span>5.</span>Открытие счета:</h2>

        <p class="block">
          <span>5.1</span> Для того чтобы использовать услуги Клуба, Вы должны пройти регистрацию, указав свой адрес
          электронной почты и выбрав пароль, который в дальнейшем будет использоваться для входа в систему, а также
          предоставить информацию личного характера, в том числе Ваше имя, дату рождения и номер телефона.
        </p>

        <p class="block">
          <span>5.2</span> Ваше имя при регистрации должно соответствовать Вашему истинному и правильно указанному
          имени. Для подтверждения представленной информации, Клуб имеет право в любой момент запросить документ,
          удостоверяющий Вашу личность. Если Вы не предоставляете или не можете предоставить нам такую информацию, то
          Клуб вправе приостановить действие Вашего аккаунта до тех пор, пока Вы не предоставите нам данную информацию,
          и/или окончательно закрыть Ваш счет в случае ее непредставления.
        </p>

        <p class="block">
          <span>5.3</span> Вы подтверждаете, что при регистрации в игровом клубе, Вы предоставили точную, полную и
          достоверную информацию о себе, и в случае каких-либо изменений, Вы будете вносить в эти сведения
          соответствующие исправления. Невыполнение этого требования может привести к применению ограничений,
          невыполнению сделок (бонусы, выигрыши) и/или закрытию Вашего аккаунта.
        </p>

        <h2><span>6.</span>Имя пользователя, пароль и безопасность:</h2>

        <p class="block">
          <span>6.1</span> После открытия счета, Вы не должны раскрывать/сообщать кому-либо (намеренно или случайно)
          Вашего логина и пароля. Если Вы потеряли или забыли данные Вашего аккаунта, Вы можете восстановить пароль,
          нажав на кнопку " Забыли пароль? " по ссылке, которая расположена ниже окна Входа.
        </p>

        <p class="block">
          <span>6.2</span> Вы обязуетесь создать сложный пароль, не использовать пароль схожий с логином или Вашей
          почтой. Советуем воспользовать любым генератором паролей с использование цифр, прописных букв, а также спец
          символов.
        </p>

        <p class="block">
          <span>6.3</span> Вы несете полную ответственность за сохранность Вашего пароля и ответственность за любые
          действия и транзакции, производимые на Вашем аккаунте. Также Вы ответственны за все убытки на Вашем аккаунте,
          понесенные Вами по вине действий третьих лиц.
        </p>

        <p class="block">
          <span>6.4</span> Вы соглашаетесь с тем, что обязаны немедленно уведомить Клуб о любом случае
          несанкционированного доступа к Вашему аккаунту и/или о любом нарушении безопасности. Вы соглашаетесь по
          запросу предоставить Клубу доказательства такого несанкционированного доступа. Клуб ни при каких
          обстоятельствах не несет ответственности, за какой бы то ни было ущерб, понесенный Вами в результате
          неправильного использования Вашего логина и пароля другим лицом или за неразрешенный доступ к Вашему аккаунту,
          вне зависимости от того, были ли они авторизованы Вами или без Вашего ведома.
        </p>

        <h2><span>7.</span>Запрещенные действия на сайте Клуба:</h2>

        <p class="block">
          <span>7.1</span> Запрещается использовать оскорбительную или агрессивную манеру общения или изображения;
          применять ненормативную лексику, угрозы, принижения или насильственные действия по отношению к к игрокам и
          сотрудникам Клуба.
        </p>

        <p class="block">
          <span>7.2</span> Вы не имеете права загружать на сайт информацию в таком объеме, который может вызвать сбои в
          работе Клуба, а также осуществлять какие-либо действия, которые могут повлиять на функционирование сайта в
          любой форме, например, но не ограничиваясь, использование и/или распространение вирусов или аналогичных
          вредоносных программ. Любая массовая рассылка информации или "спам" строго запрещены. Запрещается вмешиваться
          или искажать, удалять или иным образом изменять любую информацию, находящуюся в Клубе.
        </p>

        <p class="block">
          <span>7.3</span> Вы обязуетесь не взламывать, не пытаться взломать и/или получить доступ, или иным образом
          обойти нашу систему безопасности. Если у нас появятся подозрения, что Вы пытались или пытаетесь взломать,
          получить доступ или иным образом обойти нашу систему безопасности или программное обеспечение, мы будем
          вынуждены немедленно запретить Вам доступ к услугам Клуба и заблокировать Ваш аккаунт; мы также сохраняем за
          собой право проинформировать об этом соответствующие органы.
        </p>

        <p class="block"><span>7.4</span> Запрещено продавать или передавать аккаунты между игроками.</p>

        <p class="block">
          <span>7.5</span> Запрещено иметь более одного аккаунта на сайте, если открытие второго аккаунта связано с
          потерей доступа к первому аккаунту, или по любой другой уважительной причине, необходимо в обязательном
          порядке уведомить Клуб о желании открыть второй аккаунт и получить разрешение на открытие второго аккаунта от
          администрации Клуба до его открытия.
        </p>

        <h2><span>8.</span>Срок действия и закрытие аккаунта:</h2>

        <p class="block">
          <span>8.1</span> Вы можете прекратить действие Вашего аккаунт (в том числе удалить имя пользователя и пароль)
          в любое время, отправив нам письмо на support@mln.casino и указав причину удаления. Рассмотрение и удаление
          аккаунта производиться в течении 30 календжарных дней.
        </p>

        <p class="block">
          <span>8.2</span> Пока Вы не получили подтверждения о закрытии Вашего аккаунта, Вы несёте ответственность за
          любую деятельность на Вашем аккаунте в промежуток времени с момента, когда Вы отправили нам письмо, и до
          момента, когда Ваш аккаунт был полностью удалён Клубом.
        </p>

        <p class="block">
          <span>8.3</span> Основываясь на данных условиях, в случае аннулирования Вашего аккаунта ни одна из сторон не
          имеет никаких дальнейших обязательств по отношению к друг другу.
        </p>

        <p class="block">
          <span>8.4</span> При отсутствии активности на Вашем аккаунте свыше 6 месяцев с момента последней операции,
          Администрация Клуба без уведомления закрыть Ваш аккаунт или приостановить его действие.
        </p>

        <h2><span>9.</span>Бонусы:</h2>

        <p class="block">
          <span>9.1</span> Бонус "Возврат" не распространяется на средства выигранные во время проведения турнира или
          акций, а также на персональные бонусы.
        </p>

        <p class="block">
          <span>9.2</span> Каждый новый игрок имеет возможность получить приветственный бонус и только единожды.
        </p>

        <p class="block">
          <span>9.3</span> При активации бонуса возможность произвести вывод средств с игрового счета отключается до тех
          пор, пока бонус не будет закрыт, т.е. отыгран по вейджеру или же проигран. Данное ограничение не
          распространяется на средства, которые были до активации бонуса или на депозиты, совершенные после. При
          условии, что эти средства не являются депозитом, за счет которого был получен депозитный бонус.
        </p>

        <p class="block">
          <span>9.4</span> В период отыгрыша бонуса по вейджеру ваши ставки не учитываются в рост уровня до тех пор,
          пока бонус не будет закрыт.
        </p>

        <p class="block">
          <span>9.5</span> Сумма ставок, которую необходимо произвести, чтобы отыграть бонус, отображается в окне кассы
          во вкладке Бонус - Активный бонус.
        </p>

        <p class="block">
          <span>9.6</span> При использовании игроком бездепозитного бонуса и отсутствии по игровому счету достаточной
          активности в виде депозитов и ставок, мы оставляем за собой право потребовать внести депозит на всю сумму
          выигрыша перед тем, как осуществить вывод выигранных средств, во избежание отмывания и злоупотребления
          бонусами.
        </p>

        <p class="block">
          <span>9.7</span> Бонус на депозит должен быть активирован не позднее, чем через 24 часа после совершения
          депозита. Сумма депозита должна быть неизменна на момент активации бонуса. В противном случае бонус будет
          недоступен.
        </p>

        <p class="block"><span>9.8</span> При активном бонусе получение фриспинов (FS) невозможно.</p>

        <p class="block">
          <span>9.9</span> Мы оставляем за собой право приостанавливать, отзывать или отменять любые выплаты или
          выигрыши, связанные с бонусными предложениями при подозрении, что пользователь пытается ими злоупотреблять.
          Злоупотреблениями считаются:
        </p>

        <p class="block">
          <span>9.9.1</span> Использование более одного игрового счета с целью получить один бонус несколько раз;
        </p>

        <p class="block"><span>9.9.2</span> Игра на нескольких счетах/используя посредников;</p>

        <p class="block">
          <span>9.9.3</span> Использование различных стратегий и приемов с целью отмывания бонуса с минимальным риском;
        </p>

        <p class="block">
          <span>9.9.4</span> Получение бонусов по промо-коду, который не предназначался данному игровому счету, а был
          получен от третьих лиц, в том числе с различных форумов и прочих ресурсов. Распространение таких промо-кодов
          также является нарушением и приводит к блокировке аккаунта;
        </p>

        <p class="block">
          <span>9.9.5</span> Систематическое получение исключительно бонусных предложений при отсутствии реальных
          депозитов и ставок является злоупотреблением бонусами;
        </p>

        <p class="block">
          <span>9.9.6</span> Использование бонусов казино с целью обогащения является злоупотреблением; - Необоснованно
          множественные дублирующиеся финансовые операции за короткий промежуток времени.
        </p>

        <p class="block">
          <span>9.10</span> Для активации бонуса или фриспина за определнную сумму депозита, Вам нужно совершить депозит
          на определнную сумму указанную в условиях получения бонуса или фриспина и сразу же активировать бонус или
          фриспин. Если после депозита Вы начали играть, то активировать бонус или фриспин невозможно.
        </p>

        <h2><span>10.</span>Уровни:</h2>

        <p class="block">
          <span>10.1</span> Чтобы достигать новых уровней вам нужно делать ставки, за которые вы будете получать баллы.
          У каждого уровня есть установленная сумма баллов, необходимая для его получения. 500 рублей сделанных вами
          ставок даст вам 1 балл, независимо от того сыграла ставка или нет. Ваш текущий уровень и сумма баллов
          отображаются в строке статуса в верхней части сайта, а также в кассе.
        </p>

        <p class="block">
          <span>10.2</span> Баллы зачисляются только при ставках в игровых автоматах. Ставки в рулетках в рост уровня
          учтены не будут.
        </p>

        <h2><span>11.</span>Список выигрышей:</h2>

        <p class="block">
          <span>11.1</span> Администрация Клуба оставляет за собой право публиковать логин Клиента в списке последних
          выигрышей и в любых других материалах по усмотрению Администрации Клуба.
        </p>

        <h2><span>12.</span>AML - противодействие отмыванию денег:</h2>

        <p class="block">
          <span>12.1</span> 12.1 Принимая во внимание данные вам права на пользование услугами, вы гарантируете,
          подтверждаете, обязуетесь и соглашаетесь, что:
        </p>

        <p class="block">
          <span>12.2</span> Ваш возраст составляет не менее 18 лет или соответствует возрасту совершеннолетия, который
          является законодательно разрешенным для участия в азартных играх согласно законодательству вашей юрисдикции.
        </p>

        <p class="block">
          <span>12.3</span> Вы являетесь полноправным владельцем денежных средств на вашем счету. Вся информация,
          которую вы предоставили Клубу в процессе регистрации и/или в последующее время, в том числе в рамках любой
          сделки, которая требует внесения денежных средств, является верной, актуальной, точной и в полной мере
          соответствует имени (именам) на кредитной/дебетовой расчетной карте(-ах) или другим расчетным счетам, которые
          будут использоваться для внесения или получения средств на ваш счет/c вашего счета.
        </p>

        <p class="block">
          <span>12.4</span> Вы в полной мере осознаете, что в процессе использования услуг Клуба существует риск потери
          денежных средств, и вы несете полную ответственность за любые потери, связанные с использованием услуг Клуба.
          Вы согласны с тем, что пользуетесь услугами исключительно по собственному выбору, решению и на свой
          собственный риск. Вы не имеете права предъявлять какие-либо претензии к Клубу в связи с вашими убытками,
          потерями и/или проигрышами.
        </p>

        <p class="block">
          <span>12.5</span> Вы полностью понимаете общие способы, правила и процедуры предоставления услуг и игры в
          Интернете. Вы понимаете, что несете ответственность за обеспечение правильности данных ставок и игр. Вы
          обязуетесь не совершать какие-либо действия или поступки, которые могут нанести ущерб репутации Клуба.
        </p>

        <p class="block">
          <span>12.6</span> Соглашаясь с Условиями, вы наделяете нас правом периодического проведения любых проверок (по
          усмотрению Администрации), либо которые будут требоваться третьими сторонами (включая, в том числе,
          регулятивные органы) для подтверждения вашей личности и контактной информации («Проверка»).
        </p>

        <p class="block">
          <span>12.7</span> Во время проведения Проверок мы можем ограничить вашу возможность вывода денежных средств с
          вашего счета.
        </p>

        <p class="block">
          <span>12.8</span> Если какая-либо предоставленная вами информация является ложной, неточной, вводящей в
          заблуждение и/или иным образом неполной, то вы нарушаете условия договора, и мы имеем право закрыть Ваш счет
          незамедлительно и/или отказать Вам в использовании услуг Клуба в дополнение к любым другим действиям по своему
          усмотрению.
        </p>

        <p class="block">
          <span>12.9</span> Мы можем в любое время, без предварительного уведомления, запретить Вам доступ к услугам
          Клуба и заблокировать Ваш счет, в случае, если мы заподозрим Вас в мошенничестве или мошеннической
          деятельности. В данном случае мы снимаем с себя обязательство возвратить или иным образом компенсировать Вам
          средства, находящиеся на Вашем счете. Мы также сохраняем за собой право проинформировать об этом
          соответствующие органы и, Вы обязаны сотрудничать с Компанией в расследовании данной ситуации.
        </p>

        <p class="block">
          <span>12.10</span> Вам запрещено использовать услуги и/или программное обеспечение для любого незаконного или
          мошеннического действия, или для любой незаконной или мошеннической транзакции (включая отмывание денег) в
          соответствии с законодательством страны Вашей юрисдикции. Клуб оставляет за собой право в любое время
          приостановить или заблокировать Ваш и любые другие Ваши счета в системе и удержать денежные средства. В данном
          случае Вы отказываетесь от любых претензий в адрес Клуба.
        </p>

        <h2><span>13.</span> KYC - знай своего клиента:</h2>

        <p class="block">
          <span>13.1</span> Данные Условия определяют процедуру KYC для каждого клиента, Пользователя, который
          использует Услуги Клуба. Каждое определение трактуется только одним путем, как это описано в тексте Договора.
          Если Пользователь использует портал и/или Услуги и Товары портала, он подчиняется процедуре KYC. Она относится
          ко всем Лотереям, Турнирам, Играм и другим активностям/товарам/услугам, предоставляемым Поставщиком. KYC
          позволяет идентифицировать Пользователя на портале, а также верифицировать источник средств в его аккаунте.
        </p>

        <p class="block">
          <span>13.2</span> Для участия в любых активностях на портале, ставок и игры Пользователь обязан:
        </p>

        <p class="block">
          <span>13.2.1</span> Иметь 18 лет или больше, чтобы являться совершеннолетним по законодательству страны, в
          которой проживает Пользователь;
        </p>

        <p class="block"><span>13.2.2</span> Являться физическим, а не юридическим лицом;</p>

        <p class="block"><span>13.2.3</span> Практиковать только любительскую игру;</p>

        <p class="block">
          <span>13.3</span> В случае выяснения факта несовершеннолетия, ставки и любые бонусы признаются
          недействительными, а депозиты перечисляются обратно на счет. Так же Пользователь должен выполнить такие
          условия:
        </p>

        <p class="block">
          <span>13.3.1</span> Внести все обязательные данные в анкету: действующий email, уникальный логин и надежный
          пароль, желаемая валюта личного счета.
        </p>

        <p class="block">
          <span>13.3.2</span> Подтвердить личность, ввести только актуальные данные. Понимать, что за правдивость и
          точность предоставленной информации отвечает Пользователь. Все данные будут проверены Поставщиком. В случае,
          если Пользователь внес заведомо неправдивые данные, Поставщик оставляет за собой право блокировать или удалить
          аккаунт.
        </p>

        <p class="block">
          <span>13.3.3</span> Во время создания аккаунта придумать логин и пароль. При входе в аккаунт использовать
          только эти логин и пароль. Помнить и охранять логин и пароль от взлома, никому не передавать эти данные. В
          случае умышленной или неумышленной передачи логина и пароля Поставщик не несет ответственности за любые
          действия, совершенные с аккаунтом.
        </p>

        <p class="block">
          <span>13.3.4</span> Использовать свои логин и пароль только в личных целях. Самостоятельно пополнять счет,
          принимать участие в активностях на портале, делать ставки. В случае, если данными завладеют мошенники,
          Поставщик не несет ответственности за любые события, связанные с аккаунтом. Правильный логин и пароль дает
          право Поставщику расценивать все последующие операции действительными и законными. Поставщик не запрашивает
          пароль у Пользователя и не несет ответственности в случае, если Пользователь использует общедоступные данные о
          себе как части пароля. Пользователь полностью отвечает за сохранность личных данных. Выполняйте все правила
          безопасного доступа: не сохраняйте логин и пароль в браузере, выходите из системы и закрывайте вкладку перед
          тем, как отойти от компьютера/игрового гаджета, не входите в аккаунт в публичных местах с использованием
          публичных сетей. В случае подозрения на доступ к аккаунту третьих лиц, сообщайте Поставщику сразу же. В случае
          подозрения, что несовершеннолетние лица играют или иначе используют продукты портала, также сообщайте
          Поставщику.
        </p>

        <p class="block">
          <span>13.4</span> Во избежание отмывания денег невозможно проводить финансовые операции без подтверждения
          личности. Для подтверждения необходимы такие копии документов: выписка по счету в банке, с которого вносились
          средства, фото банковской карты с двух сторон, с которой вносились средства. На снимке должны быть закрыты все
          цифры номера кроме первых шести и последних четырех. Если тиснение видно на обратной стороне карты, необходимо
          закрыть и его. CVV2-код необходимо закрыть. Также понадобятся копии водительского удостоверения, паспорта и
          идентификационного кода. К верификации принимается любой из этих документов на выбор Пользователя.
        </p>

        <p class="block">
          <span>13.5</span> Поставщик услуг работает в соответствии с Лицензией. Все личные данные используются только
          для процедуры KYC. Это гарантия того, что Поставщик всегда определяет Пользователя по паролю и логину. Тем
          самым Поставщик также выполняет обязательства об ответственной игре и понимании механизмов пополнения счета.
        </p>

        <p class="block">
          <span>13.6</span> Запрос о получении копий вышеперечисленных документов Поставщик может предъявить в любое
          время и без любых объяснений. Также для процедуры KYC используются общение по видео и телефонной связи.
          Поставщик имеет право узнать источник депозитов, уточнить активность в данной Учетной записи. Используется
          также переписка и документы.
        </p>

        <p class="block">
          <span>13.7</span> В случае, если Пользователь не выполняет требований, не выходит на связь и не предоставляет
          данные, работа его учетной записи приостанавливается до момента получения Поставщиком необходимых данных. Если
          Пользователь подозревается в преступлении и других неправомерных действиях, Поставщик сообщает об этом
          правоохранительным органам и в другие инстанции без предупреждения.
        </p>
      </div>
      <site-info />
    </div>

    <bonuses-line />

    <play-line />
  </div>
</template>

<script>
import SliderRules from '@/components/sliders/SliderRules'
import PlayLine from '@/components/PlayLine'
import BonusesLine from '@/components/BonusesLine.vue'
import TheNav from '@/components/TheNav'
import SiteInfo from '@/components/SiteInfo'

export default {
  name: 'Rules',
  components: { SliderRules, PlayLine, BonusesLine, TheNav, SiteInfo },
  data() {
    return {
      show: false,
    }
  },
}
</script>

<style scoped></style>
